module.exports = __webpack_public_path__ + "static/media/directions_car.d94a67ce.svg";